import React, { PureComponent } from 'react';
import Modal from '../../../../../../components/Modal';
import enums from "../../../../../../constants/enums";

import SellPaymentFilters from './SellPaymentFilters';

class SellPaymentsModalView extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      sellPaymentsModalActive,
      closeSellPaymentsModal,
      togglePayment,
      payments,
      selectedPayments,
      total,
      totalAvailable,
      trade,
    } = this.props;
    return (
      <Modal
        className="modal-container sell-payments-modal"
        active={sellPaymentsModalActive}
        onClose={closeSellPaymentsModal}
      >
        {enums.giftcardLinks[trade.type] && !enums.giftcardLinks[trade.type].cantPurchase && (
          <div className="warning">
            Don't forget you can purchase {trade.type} cards to resell if we don't have any in our inventory.
          </div>
        )}
        <SellPaymentFilters
          onFilterChange={this.props.onFilterChange}
          trade={trade}
        />
        <div className="totals">
          Total: ${totalAvailable}(Selected) + ${total}(Paid) =  ${totalAvailable + total}
        </div>
        <div className="sell-payments">
          <div className="title">Payments</div>
          <table>
            <thead>
            <tr>
              <th></th>
              <th>Code</th>
              <th>Pin</th>
              <th>Type</th>
              <th>Status</th>
              <th>Date</th>
              <th>Value</th>
              <th>Remaining</th>
            </tr>
            </thead>
            <tbody>
            {payments && payments.map((payment, i)=>{
              const date = (payment.trade && payment.trade.date) || payment.date;
              return (
                <tr key={i}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedPayments.indexOf(payment._id) > -1}
                      onClick={e => {
                        togglePayment({
                          checked: e.target.checked,
                          _id: payment._id,
                        });
                      }}
                    />
                  </td>
                  <td>{payment.code}</td>
                  <td>{payment.pin}</td>
                  <td>{payment.type}</td>
                  <td>{(enums.paymentStatusMap[payment.status] || {}).label}</td>
                  <td>{date && new Date(date).toLocaleDateString()}</td>
                  <td>{payment.value}</td>
                  <td>{payment.remainingValue}</td>
                </tr>
              );
            })}


            </tbody>
          </table>
        </div>
      </Modal>
    )
  }
}

export default SellPaymentsModalView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsModal/SellPaymentsModal.view.js